import { render, staticRenderFns } from "./OptionalRouterLink.vue.html?vue&type=template&id=17e84684&"
import script from "./OptionalRouterLink.component.js?vue&type=script&lang=vueJs&"
export * from "./OptionalRouterLink.component.js?vue&type=script&lang=vueJs&"
import style0 from "./OptionalRouterLink.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports